import React from 'react';
import { BrainIcon, HeartHandshakeIcon, SproutIcon } from 'lucide-react';
const benefits = [{
  icon: BrainIcon,
  title: 'Psicología aplicada',
  description: 'Explicada de forma clara y cercana.'
}, {
  icon: HeartHandshakeIcon,
  title: 'Gestión emocional',
  description: 'Herramientas para habitar lo que sentís.'
}, {
  icon: SproutIcon,
  title: 'Desarrollo personal',
  description: 'Un camino práctico, paso a paso.'
}];
export function SocialProof() {
  return <section className="border-y border-clay/15 bg-rose/35 px-4 py-12" data-id="element-181" data-mp="3h7mf55paqpn">
      <div className="mx-auto grid max-w-5xl gap-7 md:grid-cols-3 md:gap-10" data-id="element-182" data-mp="8d6d4zei4kt8">
        {benefits.map(({
        icon: Icon,
        title,
        description
      }) => <article key={title} className="flex items-start gap-4 text-center md:text-left" data-id="element-183" data-mp="3usr2z1oemohy">
            <div className="mx-auto flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-clay-dark shadow-sm md:mx-0" data-id="element-184" data-mp="mdh5y7zdg9h1">
              <Icon className="h-5 w-5" aria-hidden="true" data-id="element-185" data-mp="r5qsrf56wtf3" />
            </div>
            <div data-id="element-186" data-mp="1uammbutxxlxw">
              <h2 className="font-heading text-xl font-semibold text-ink" data-id="element-187" data-mp="1ua4fk49njpbq">{title}</h2>
              <p className="mt-1 text-sm leading-6 text-ink/65" data-id="element-188" data-mp="1pcbbbgrwt5e3">{description}</p>
            </div>
          </article>)}
      </div>
    </section>;
}